// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 511) return "static/chunks/511-bb08a027147abbcd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"293":"160e9e395587a8fe","674":"2757162ce50c8755"}[chunkId] + ".js";
};